// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorizationModal_container__2mO4J","authBox":"AuthorizationModal_authBox__TdrAa"};